import { CategoricalBarChartTooltipProps } from '../types/categorical-bar-chart.js';

/**
 * Tooltip slot component.
 */
export const Tooltip = (props: CategoricalBarChartTooltipProps) => null;

Tooltip['displayName'] = 'CategoricalBarChart.Tooltip';
